"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var DateBetweenDto_1;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateBetweenDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const transform_iso8601_date_1 = __importDefault(require("../../pipes/transform-iso8601-date"));
const swagger_1 = require("../../../swagger-fake");
let DateBetweenDto = DateBetweenDto_1 = class DateBetweenDto {
  /** Из похожего объекта или объекта того же типа */
  static fromLike(obj) {
    if (obj instanceof DateBetweenDto_1) {
      return (0, class_transformer_1.instanceToInstance)(obj);
    }
    const filter = new DateBetweenDto_1();
    filter.from = obj.from;
    filter.to = obj.to;
    return filter;
  }
};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Транзакции созданные начиная с даты",
  required: false,
  type: 'string',
  format: 'date-time'
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Object)], DateBetweenDto.prototype, "from", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Транзакции созданные до даты",
  required: false,
  type: 'string',
  format: 'date-time'
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Object)], DateBetweenDto.prototype, "to", void 0);
DateBetweenDto = DateBetweenDto_1 = __decorate([(0, class_transformer_1.Exclude)()], DateBetweenDto);
exports.DateBetweenDto = DateBetweenDto;
